import { ChevronLeft, Cookie } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import { sanitizeNewsHtml } from '@/features/news/lib'
import { useConsentStore } from '@/features/consent/consentStore'
import { PRIVACY_LAST_UPDATED, privacyHtml } from './privacyContent'

/**
 * Informativa privacy. Il contenuto (portato dalla v1 + sezione cookie/GA4)
 * vive in `privacyContent.ts` come HTML, qui viene sanitizzato con DOMPurify
 * (riuso di `sanitizeNewsHtml`) e renderizzato. Lo styling è dato dalla classe
 * `.news-content` (src/index.css), lo stesso meccanismo usato per le news.
 *
 * Pagina pubblica: linkata dal banner consenso cookie e dalla pagina di login.
 */
export function PrivacyPage() {
  const html = sanitizeNewsHtml(privacyHtml)
  const openPreferences = useConsentStore((s) => s.openPreferences)

  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-4 px-4 py-10">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <Link
          to="/"
          className="inline-flex w-fit items-center gap-1 text-sm font-semibold text-secondary hover:underline"
        >
          <ChevronLeft className="h-4 w-4" />
          Torna indietro
        </Link>
        {/* Revoca/modifica del consenso: riapre il dialog preferenze cookie
            (requisito GDPR — la scelta dev'essere modificabile in ogni momento). */}
        <Button variant="outline" size="sm" onClick={openPreferences}>
          <Cookie className="h-4 w-4" />
          Gestisci preferenze cookie
        </Button>
      </div>

      <Card className="p-0">
        <div
          className="news-content max-w-none p-6 md:p-8"
          dangerouslySetInnerHTML={{ __html: html }}
        />
        <p className="border-t border-border px-6 pb-6 pt-4 text-xs text-muted-foreground md:px-8">
          Ultimo aggiornamento: {PRIVACY_LAST_UPDATED}
        </p>
      </Card>
    </div>
  )
}
